import { isLoggedInUser } from '../../common/auth';
import { ClientId, SelectedOrg, SelectedProduct, SupportOrgToken, JWT } from '../../common/keys';
import {
  product_list as productListUrl,
  commerceProduct as commerceProductUrl,
  profile as profileUrl,
  role as roleUrl,
} from '../../common/urls';
import { request } from '../../common/request';
import { log } from '../../common/log';
import { getSelectedOrg } from './support-org-util';
import { keys as headerKeys, values as headerValues } from '../../common/headers';
import { appShadowRoot } from '../../common/elements';
import { productToFamilyMapping } from '../utils/support-constants';
import { relicApiFail, relicApiSuccess } from './relic';

const RELIC_CASE_CREATION_AVAILABILITY_TRACKING = {
  title: 'Case Creation Availability',
  duration: 10,
};

export async function getRoles() {
  try {
    let profileData = await adobeIMS.getProfile();
    let res = await request(roleUrl, {
      credentials: 'include',
      headers: {
        Authorization : `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
        [headerKeys.accept]: headerValues.json,
      },
      params:{
        auth_id: profileData.userId,
        user_id: profileData.userId
      }
    });
    const data = await res.json(); 
    console.log('roles data', data);
    
    return data;
  } catch (error) {
    console.log('roles data error', error);
    
    log(`error in getroles: ${error}`);

    return error;
  }
}

export const getProductList = async (productOrg, type = null, onlyPSA = false) => {
  
  const authenticated = await isLoggedInUser();
  if (authenticated) {
    const productPicker = appShadowRoot.querySelector('#support-product-picker');
    const productFilterPicker = appShadowRoot.querySelector('#support-case-product-picker');
    const productPickerLoader = appShadowRoot.querySelector('#product-picker-loader');
    const productFilterLoader = appShadowRoot.querySelector('#product-filter-loader');
    const current_org = getSelectedOrg();
    if (current_org !== null && productOrg !== current_org.id) {
      let products = [];
      if (
        current_org.type !== 'WORKFRONT' &&
        current_org.type !== 'ECC' && 
        current_org.type !== 'COMMERCE' &&
        sessionStorage.getItem(SupportOrgToken)
      ) {
        const productEndPoint = productListUrl.replace('#ORG_ID', current_org.id);
        const productListStart = performance.now();
        const productListDuration = Number((performance.now() - productListStart) );
        try {
          const requestHeaders = {};
          requestHeaders['x-api-key'] = ClientId;
          // requestHeaders.Authorization = `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`;
          requestHeaders.Authorization = sessionStorage.getItem(SupportOrgToken) || '';
          if (productPicker && !productPicker.classList.contains('is-hidden')) {
            productPicker.classList.add('is-hidden');
          }
          if (productPickerLoader && productPickerLoader.classList.contains('is-hidden')) {
            productPickerLoader.classList.remove('is-hidden');
          }

          if (productFilterPicker && !productFilterPicker.classList.contains('is-hidden')) {
            productFilterPicker.classList.add('is-hidden');
          }
          if (productFilterLoader && productFilterLoader.classList.contains('is-hidden')) {
            productFilterLoader.classList.remove('is-hidden');
          }
            requestHeaders['Accept-Language'] = 'es,es-ES;q=0.9,en;q=0.8,en-GB;q=0.7,en-US;q=0.6,es-CL;q=0.5';        

          let res, data;
          for (let attempt = 0; attempt < 3; attempt++) {
            res = await request(productEndPoint, {
              headers: {...requestHeaders},
              params: {},
              key: 'jil-product-list'
            });

            data = await res.json();
            if (res.ok) break;

            if (attempt === 2 && !res.ok) {
              throw new Error(`Failed to retrieve Products list after 3 attempts: ${data?.error || 'Unknown error'}`);
            }
          }
          if (res.ok) {
            
            relicApiSuccess({
              endpoint: productEndPoint,
              duration: productListDuration,
              ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
            });
            if (Array.isArray(data)) {
  
              let productData = data;
              if (productData.length) {
                for (const product of productData) {
                  const hasCreateAccess =
                    product.fulfillableItems.filter(
                      (fulfillableItem) => fulfillableItem.code === 'support_case_creation_allowed',
                    ).length > 0;
                  if (hasCreateAccess) {
                    const hasTypeSupport =
                      product.fulfillableItems.filter(
                        (fulfillableItem) => fulfillableItem.fulfillableItemType === 'SUPPORT',
                      ).length > 0;
                    if (hasTypeSupport) {
                      for (const fulfillableItem of product.fulfillableItems) {
                        if (fulfillableItem.fulfillableItemType === 'SUPPORT') {
                          const productItem = {};
                          // console.log('fulfillableItem.code', fulfillableItem.code);
                          
                          productItem.familyName = productToFamilyMapping[fulfillableItem.code] ? productToFamilyMapping[fulfillableItem.code] : '';
                          if (fulfillableItem.code.toLowerCase().startsWith('dx_advertising_search_support')) {
                            const longName = product.fulfillableEntityResourceName ?
                              `${fulfillableItem.enterpriseName} - ${product.fulfillableEntityResourceName}` :
                              product.longName;
                            productItem.proId = product.id;
                            productItem.licenseId = product.id;
                            productItem.id = fulfillableItem.code;
                            productItem.label = longName;
                            productItem.type = fulfillableItem.fulfillableItemType;
                            products.push(productItem);
                          } else if (fulfillableItem.code.startsWith('dx_')) {
                            productItem.id = fulfillableItem.code;
                            productItem.label = fulfillableItem.enterpriseName;
                            productItem.type = fulfillableItem.fulfillableItemType;
                            if (!products.find((pro) => pro.id === productItem.id && pro.label === productItem.label)) {
                              products.push(productItem);
                            }
                          } else if (fulfillableItem.code.toLowerCase().startsWith('mkto_')) {
                            const longName = product.fulfillableEntityResourceName
                              ? `${product.longName} - ${product.fulfillableEntityResourceName}`
                              : product.longName;
                            productItem.proId = product.id;
                            productItem.licenseId = product.id;
                            productItem.id = fulfillableItem.code;
                            productItem.label = longName;
                            productItem.type = fulfillableItem.fulfillableItemType;
                            products.push(productItem);
                          } else if (fulfillableItem.code.toLowerCase().startsWith('amm_')) {
                            const longName = product.fulfillableEntityResourceName
                              ? `${product.longName} - ${product.fulfillableEntityResourceName}`
                              : product.longName;
                            productItem.proId = product.id;
                            productItem.id = fulfillableItem.code;
                            productItem.label = longName;
                            productItem.type = fulfillableItem.fulfillableItemType;
                            products.push(productItem);
                          }
                        }
                      }
                    } else {
                      for (const fulfillableItem of product.fulfillableItems) {
                        if (fulfillableItem.fulfillableItemType === 'DESKTOP') {
                          let productItem = {};
                          productItem.familyName = productToFamilyMapping[fulfillableItem.code] ? productToFamilyMapping[fulfillableItem.code] : '';
                          if (fulfillableItem.code.toLowerCase().startsWith('dx_advertising_search_support')) {
                            const longName = product.fulfillableEntityResourceName ?
                              `${fulfillableItem.enterpriseName} - ${product.fulfillableEntityResourceName}` :
                              product.longName;
                            productItem.proId = product.id;
                            productItem.licenseId = product.id;
                            productItem.id = fulfillableItem.code;
                            productItem.label = longName;
                            productItem.type = fulfillableItem.fulfillableItemType;
                            products.push(productItem);
                          } else if (fulfillableItem.code.startsWith('dx_')) {                            
                            productItem.id = fulfillableItem.code;
                            productItem.label = fulfillableItem.enterpriseName;
                            productItem.type = fulfillableItem.fulfillableItemType;
                            if (!products.find((pro) => pro.id === productItem.id && pro.label === productItem.label)) {
                              products.push(productItem);
                            }
                          } else if (fulfillableItem.code.toLowerCase().startsWith('mkto_')) {
                            const longName = product.fulfillableEntityResourceName
                              ? `${product.longName} - ${product.fulfillableEntityResourceName}`
                              : product.longName;
                            productItem = {};
                            productItem.proId = product.id;
                            productItem.licenseId = product.id;
                            productItem.id = fulfillableItem.code;
                            productItem.label = longName;
                            productItem.type = fulfillableItem.fulfillableItemType;
                            products.push(productItem);
                          } else if (fulfillableItem.code.toLowerCase().startsWith('amm_')) {
                            const longName = product.fulfillableEntityResourceName ?
                              `${product.longName} - ${product.fulfillableEntityResourceName}` :
                              product.longName;
                            productItem.proId = product.id;
                            productItem.id = fulfillableItem.code;
                            productItem.label = longName;
                            productItem.type = fulfillableItem.fulfillableItemType;
                            products.push(productItem);
                          }
                        }
                      }
                    }
                  }
                }
              }

              const filterMarketoProduct = products.some((prod) => prod.id.startsWith('mkto'));
              if (filterMarketoProduct) {
                const unFilteredProducts = products;
                let roles = await getRoles();
                let toBeFilterProducts = roles?.roles ? roles?.roles : [];
                
                let filteredArray = unFilteredProducts.filter((obj) => {
                  if(!onlyPSA){
                    if (!obj.hasOwnProperty('proId')) return true;
                    if (!obj.id.startsWith('mkto_')) return true;
                  }
                  return toBeFilterProducts.some((productObj) => productObj.target === obj.proId);
                });

                products = filteredArray;
              }
              log('Products List');

              

              if (productPicker && productPicker.classList.contains('is-hidden')) {
                productPicker.classList.remove('is-hidden');
              }
              if (productPickerLoader && !productPickerLoader.classList.contains('is-hidden')) {
                productPickerLoader.classList.add('is-hidden');
              }
            }
          } else {
            relicApiFail({
              status:data.status,
              endpoint: productEndPoint,
              duration: productListDuration,
              ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
            });
            if (productPicker && productPicker.classList.contains('is-hidden')) {
              productPicker.classList.remove('is-hidden');
            }
            if (productPickerLoader && !productPickerLoader.classList.contains('is-hidden')) {
              productPickerLoader.classList.add('is-hidden');
            }
            log(`Failed to retrieve Products list: ${data.error}`);
          }
        } catch (err) {
          relicApiFail({
            status:err.status,
            endpoint: productEndPoint,
            duration: productListDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          if (productPicker && productPicker.classList.contains('is-hidden')) {
            productPicker.classList.remove('is-hidden');
          }
          if (productPickerLoader && !productPickerLoader.classList.contains('is-hidden')) {
            productPickerLoader.classList.add('is-hidden');
          }
          log(`Failed to retrieve Products list: ${err.message}`);
        }
      } else if (current_org.type === 'COMMERCE') {
        const commerceProductStart = performance.now();
        const commerceProductDuration = Number((performance.now() - commerceProductStart) );
        try {

        let profileData = await adobeIMS.getProfile();
        let newCommerceProductUrl = commerceProductUrl.replace('#ORG_ID#', current_org.id)
        const res = await request(newCommerceProductUrl, {
          credentials: 'include',
          headers: {
            Authorization : `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
            [headerKeys.accept]: headerValues.json,
          },
          params: {
            id: current_org.id,
            auth_id: profileData.authId
          },
          method: 'GET',
        });

        const amcData = await res.json();
       
        if (amcData.success) {
          relicApiSuccess({
            endpoint: commerceProductUrl,
            duration: commerceProductDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
        } else {
          relicApiFail({
            status:amcData.status,
            endpoint: commerceProductUrl,
            duration: commerceProductDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
        }

        if (Array.isArray(amcData.productEntitlements) && amcData.productEntitlements.length) {
          const result = amcData.productEntitlements.map((product, index, array) => {
            let label = product.name;
            if (array.filter((p) => p.name === product.name).length > 1) {
              if (product.license && type !== 'my-case') {
                label += ` - ${product.license}`;
              }
            }

            return {
              id: product.entitlement,
              label,
              type: product.supportEntitlements[0].code,
              licenseId: product.license,
              familyName : productToFamilyMapping[product.entitlement] ? productToFamilyMapping[product.entitlement] : ''
            };
          });

          const uniqueLabels = {};
          let filterProducts = result.filter((obj) => !uniqueLabels[obj.label] && (uniqueLabels[obj.label] = true));

          const isManagedServicePresent = filterProducts.some(item => item.id === 'dx_commercemanagedservices_support');
          if (isManagedServicePresent) {
            filterProducts = filterProducts.filter(item => item.id !== 'dx_commercecloud_support');
          }
          products.push(...filterProducts);
        }

        if (productPicker && productPicker.classList.contains('is-hidden')) {
          productPicker.classList.remove('is-hidden');
        }
        if (productPickerLoader && !productPickerLoader.classList.contains('is-hidden')) {
          productPickerLoader.classList.add('is-hidden');
        }
        } catch (commerceProductErr) {
          relicApiFail({
            status:commerceProductErr.status,
            endpoint: commerceProductUrl,
            duration: commerceProductDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          log(`Failed to retrieve Commerce products: ${commerceProductErr.message}`);
        }
      } else if (current_org.type === 'ECC') {
        products.push({
          id: 'ADLM',
          label: 'Learning Mgr Add On',
          type: ''
        });
        products.push({
          id: 'CAPP',
          label: 'Adobe Learning Mgr',
          type: ''
        });
      } else {
        products.push({
          id: 'WORKFRONT',
          label: 'Workfront',
          type: '',
        });
        if (productPicker && productPicker.classList.contains('is-hidden')) {
          productPicker.classList.remove('is-hidden');
        }
        if (productPickerLoader && !productPickerLoader.classList.contains('is-hidden')) {
          productPickerLoader.classList.add('is-hidden');
        }
      }

      if (products.length > 0) {
        products.sort((a, b) => (a.label > b.label ? 1 : -1));
        const lastSelected = sessionStorage.getItem(SelectedProduct);
        if (lastSelected === null) {
          // sessionStorage.setItem(SelectedProduct, JSON.stringify(products[0]));
        } else {
          const isExist = products.findIndex((product) => product.id === JSON.parse(lastSelected).id);
          if (isExist !== -1) {
            sessionStorage.setItem(SelectedProduct, lastSelected);
          }
        }
      }

      return { productList: products, orgId: SelectedOrg };
    }
    return { productList: [], orgId: SelectedOrg };
  }
  return { productList: [], orgId: SelectedOrg };
};
